const POSTAL_CODE_DIGITS = 8

/** Formata a digitacao de CEP como 00000-000, descartando o que nao e digito. */
export function formatPostalCode(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, POSTAL_CODE_DIGITS)

  if (digits.length > 5) return `${digits.slice(0, 5)}-${digits.slice(5)}`
  return digits
}

/** `true` quando o CEP tem os 8 digitos — so entao ele vale como busca exata. */
export function isCompletePostalCode(value: string): boolean {
  return value.replace(/\D/g, "").length === POSTAL_CODE_DIGITS
}
